import { Column } from "@pufflig/prompt-studio-types";
import { loadTablePreview } from "./loadTablePreview";
import { useSemanticModelStore } from "../SemanticModelProvider";

export const selectTable = async (connectorId: string, schema: string, table: string) => {
  const { dbSchema, semanticModel } = useSemanticModelStore.getState();
  if (!dbSchema) return;

  const fullName = `${schema}.${table}`;
  const connectorColumns = dbSchema.schemas?.[schema]?.tables?.[table]?.columns || [];
  const modelColumns = semanticModel?.schemas?.[schema]?.tables?.[table]?.columns || [];

  const merged: Column[] = connectorColumns.map((c) => {
    const m = modelColumns.find((mc) => mc.columnName === c.columnName);
    return { ...c, ...(m || {}), hidden: !m } as Column;
  });

  const tableInfo = semanticModel?.schemas?.[schema]?.tables?.[table];

  useSemanticModelStore.setState(
    (state) => {
      state.selectedTable = fullName;
      state.selectedTableSchema = merged;
      state.selectedTableDescription = tableInfo?.tableDescription || "";
      state.isLoadingPreview = true;
    },
    false,
    "table/select_start",
  );

  try {
    await loadTablePreview(connectorId, fullName);
  } finally {
    useSemanticModelStore.setState(
      (state) => {
        state.isLoadingPreview = false;
      },
      false,
      "table/load_preview_complete",
    );
  }
};
